class ConfigManager {
  static instance = null
  config = null
  initialized = false

  static getInstance() {
    if (!ConfigManager.instance) {
      ConfigManager.instance = new ConfigManager()
    }
    return ConfigManager.instance
  }

  async loadConfig() {
    if (this.initialized) return this.config

    try {
      // 先尝试从 localStorage 获取配置
      //const storedConfig = this.getStoredConfig();
      //if (storedConfig) {
      //this.config = storedConfig;
      //this.initialized = true;
      //return this.config;
      //}

      // 如果没有存储的配置，从 config.json 加载
      const response = await fetch('/config.json', {
        cache: 'no-store', // 完全禁用缓存，每次请求都向服务器获取最新内容
      })
      const config = await response.json()
      // 保存到 localStorage
      this.saveConfig(config)
      this.initialized = true
      return this.config
    } catch (error) {
      console.error('Failed to load config:', error)
      return null
    }
  }

  // 同步获取配置的方法
  getConfig() {
    if (!this.initialized) {
      // 如果配置未初始化，尝试从 localStorage 获取
      const storedConfig = this.getStoredConfig()
      if (storedConfig) {
        this.config = storedConfig
        this.initialized = true
      }
    }
    return this.config
  }

  getStoredConfig() {
    const url = localStorage.getItem('ApiUri')
    const port = localStorage.getItem('ApiPort')
    const httpsPort = localStorage.getItem('ApiPortHttps')
    const features = localStorage.getItem('features')
    const eepMainPath = localStorage.getItem('eepMainPath')

    if (!url || !port) return null

    const config = {
      url,
      port,
      httpsPort,
      eepMainPath,
    }

    // 添加 features 配置
    if (features) {
      try {
        config.features = JSON.parse(features)
      } catch (e) {
        console.error('Failed to parse features config:', e)
      }
    }

    return config
  }

  saveConfig(config) {
    localStorage.setItem('ApiUri', config.url)
    localStorage.setItem('ApiPort', config.port)
    localStorage.setItem('ApiPortHttps', config.httpsPort)
    localStorage.setItem('isSecond', config.isSecond)
    localStorage.setItem('dvrUrl', config.dvrUrl)
    localStorage.setItem('dvrPort', config.dvrPort)
    localStorage.setItem('videoServer', JSON.stringify(config.videoServer))
    localStorage.setItem('dvrServer', JSON.stringify(config.dvrServer))
    localStorage.setItem('eepMainPath', config.eepMainPath || '/eep/main.html')
    // 保存 features 配置
    if (config.features) {
      localStorage.setItem('features', JSON.stringify(config.features))
    }

    // 更新内存中的配置
    this.config = config
  }

  getApiUrl() {
    const config = this.getConfig()
    if (!config) return null

    const protocol = window.location.protocol
    const port = protocol === 'https:' ? config.httpsPort : config.port
    const host = process.env.NODE_ENV === 'development' ? config.url : (window.location.hostname || config.url)
    return `${protocol}//${host}:${port}`
  }

  /**
   * 获取 EEP 页面路径
   * @returns {string} eep 主页面路径
   */
  getEepMainPath() {
    const config = this.getConfig()
    const useNewEep = config?.features?.useNewEep

    if (useNewEep === true || useNewEep === 'true') {
      return config?.eepMainPath || '/eep-dist/index.html'
    }

    if (useNewEep === false || useNewEep === 'false') {
      return '/eep/main.html'
    }

    return config?.eepMainPath || '/eep/main.html'
  }

  getEepMainUrl(params = {}) {
    const url = new URL(this.getEepMainPath(), window.location.origin)

    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        url.searchParams.set(key, value)
      }
    })

    return url.toString()
  }

  getFeatures() {
    const config = this.getConfig()
    if (config && config.features) {
      return config.features
    }

    try {
      return JSON.parse(localStorage.getItem('features') || '{}')
    } catch (error) {
      return {}
    }
  }

  isSsoPasswordFeaturesEnabled() {
    const features = this.getFeatures()
    if (!Object.prototype.hasOwnProperty.call(features, 'enableSsoPasswordFeatures')) {
      return false
    }

    const featureValue = features.enableSsoPasswordFeatures
    return featureValue === true || featureValue === 'true'
  }

  isDataSourceSwitchEnabled() {
    const features = this.getFeatures()
    if (!Object.prototype.hasOwnProperty.call(features, 'enableDataSourceSwitch')) {
      return false
    }
    const featureValue = features.enableDataSourceSwitch
    return featureValue === true || featureValue === 'true'
  }

  isAlarmHandleSettingsEnabled() {
    const configFeatures = this.getConfig()?.features || {}
    let featureValue = configFeatures.useNewAlarmHandleViews

    if (!Object.prototype.hasOwnProperty.call(configFeatures, 'useNewAlarmHandleViews')) {
      try {
        featureValue = JSON.parse(localStorage.getItem('features') || '{}').useNewAlarmHandleViews
      } catch (error) {
        featureValue = undefined
      }
    }

    return featureValue === true || featureValue === 'true'
  }
}

export default ConfigManager.getInstance()
